import "./index.scss";
import { ReactComponent as ArrowIcon } from "assets/arrow-icon.svg";

export const PressArticleCard = ({ press, img, title, url }) => {
  return (
    <div className="press-article-card-container">
      <div className="logo-container">
        <img src={img} alt={`${press} - ${title}`} className="press-logo" />
      </div>
      <h3 className="title">{title}</h3>
      <p>
        <a
          target="_blank"
          rel="noreferrer"
          href={url}
          className="read-article-button"
        >
          Read the article
          <ArrowIcon alt="Read the article" className="arrow-icon" />
        </a>
      </p>
    </div>
  );
};
